export default "__VITE_ASSET__6B1kPJ8p__"